import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useCallback, useMemo } from 'react';
import { Box } from '@mui/material';
import { Interval, interval_min_size } from './interval';
import { useResizeDetector } from 'react-resize-detector';
import { intervalEndTimeSum, intervalStartTimeSum } from '../utils';
export const TimeLine = (props) => {
    const { temp_or_mode, heating_modes, day_intervals, onSelectInterval, week_view, onCreateInterval, selected_interval_id, selected_hc, is_baxi_app, } = props;
    const { width, height, ref } = useResizeDetector({
        handleHeight: false,
        refreshMode: 'throttle',
        refreshRate: 300,
    });
    const _onSelectInterval = useCallback((interval_id, interval) => {
        onSelectInterval?.(interval_id, interval != null ? 1 : null);
    }, [onSelectInterval]);
    const free_size = useMemo(() => {
        const interval_count = day_intervals.length;
        //Считаю сколько блоков у меня есть и сколько места им нужно
        const need_size = interval_min_size * interval_count;
        // Вычисляю размер, который остаётся для распределения
        const free_size = (is_baxi_app ? height ?? 100 : width ?? 100) - need_size;
        return free_size;
    }, [day_intervals, interval_min_size, is_baxi_app, height, width]);
    const interval_sizes = useMemo(() => day_intervals.map((interval) => {
        const start_sum = intervalStartTimeSum(interval);
        const end_sum = intervalEndTimeSum(interval);
        const delta = end_sum - start_sum;
        //Вес одного интервала
        const weight = (delta * 100) / 1440;
        const offset = (start_sum * 100) / 1440;
        const day_interval_size = interval_min_size + Math.abs((weight / 100) * free_size);
        return {
            top: week_view ? offset : 0,
            left: week_view ? offset : 0,
            height: week_view ? weight : day_interval_size,
            width: week_view ? weight : day_interval_size,
        };
    }), [day_intervals, week_view, free_size, interval_min_size]);
    const all_intervals = useMemo(() => day_intervals.map((interval, index) => {
        const interval_size = interval_sizes[index];
        const offset = week_view
            ? interval_size
            : interval_sizes.slice(0, index).reduce((offset, { height, width }) => ({
                top: offset.top + height,
                left: offset.left + width,
            }), {
                top: 0,
                left: 0,
            });
        const size = {
            height: interval_size.height,
            width: interval_size.width,
        };
        return (_jsx(Interval, { interval_id: index, interval: interval, heating_modes: heating_modes, week_view: week_view, offset: offset, is_baxi_app: is_baxi_app, size: size, empty: !('temp_or_mode' in interval), onSelectInterval: 'temp_or_mode' in interval
                ? _onSelectInterval
                : onCreateInterval, selected: selected_interval_id === index, selected_hc: selected_hc, temp_or_mode: temp_or_mode }, index));
    }), [
        day_intervals,
        interval_sizes,
        week_view,
        is_baxi_app,
        temp_or_mode,
        selected_hc,
    ]);
    return (_jsx(Box, { position: "relative", flexGrow: 1, height: "100%", ref: ref, children: _jsx(Box, { position: "relative", height: "100%", boxSizing: "border-box", children: all_intervals }) }));
};
